import React from 'react';
import { ErrorMessage } from 'formik';
import { Form } from 'react-bootstrap';
import { IFormControlErrorMessageProps } from './types';

export const FormControlErrorMessage: React.FC<IFormControlErrorMessageProps> = ({
  name,
}) => (
  <ErrorMessage
    name={name}
    render={(error) => (
      <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
    )}
  />
);
